var path = 'areas/configuration/audit/subscriptions/views/create.html';
var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href=\"#/configuration/audit/subscriptions/new\">Create new</a></li> </script> <div class=\"form-box form-horizontal\"> <subscription-editor></subscription-editor> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/audit/subscriptions/views/create.html
// module id = 727
// module chunks = 1